export default __webpack_public_path__ + "static/media/mountain2.c733ca27.png";